import React from "react";

import CreateInspectionLink from "../../../components/create_inspection_link/create_inspection_link";
import './index.css';

export default function ActivityCellFormatter(props) {
  const { cell, row, canCreateInspection, onCreateInspectionSuccess } = props;
  const { work_phase_or_ambient_exposure: workPhase, activity, is_custom, plan_id, inspections } = row;
  const isCustom = ["work_phase", "activity"].includes(is_custom);
  const cellClassname = isCustom ? "cell-style activity-cell editable-cell" : "cell-style activity-cell";
  
  return (
    <span className={cellClassname}>
      <div>{ cell }</div>
      {
        canCreateInspection &&
        <CreateInspectionLink
          label="Create Inspection for this activity"
          planId={plan_id}
          workPhase={workPhase}
          activity={activity}
          inspections={inspections}
          onCreateInspectionSuccess={onCreateInspectionSuccess}
        />
      }
    </span>
  )
}



// WEBPACK FOOTER //
// ./src/views/plan_tables/formatters/activity_cell_formatter.js